// extracted by mini-css-extract-plugin
export var md = "_4b-4";
export var semantic = "_4b-5";
export var sm = "_4b-3";
export var text = "_4b-6";
export var toggleInput = "_4b-0";
export var toggleSwitch = "_4b-1";
export var xs = "_4b-2";